import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BankDetails } from 'src/app/models/bank-details';

@Component({
  selector: 'bank-details',
  templateUrl: './bank-details.component.html',
  styleUrls: ['./bank-details.component.scss']
})
export class BankDetailsComponent implements OnInit {
  @Input() data: BankDetails;

  @Output() confirm = new EventEmitter<void>();
  @Output() reject = new EventEmitter<number>();

  constructor() { }

  ngOnInit() {
  }

  continueDataHandling() {
    this.confirm.emit();
  }

  correctBankDetails(event: Event) {
    event.preventDefault();

    this.reject.emit(this.data.id);
  }
}
